import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Sales from "./pages/Sales";
import Companies from "./pages/Companies";
import Services from "./pages/Services";
import Partners from "./pages/Partners";
import Sibill from "./pages/Sibill";
import Payments from "./pages/Payments";
import Catalog from "./pages/Catalog";
import Orders from "./pages/Orders";
import Attestati from "./pages/Attestati";
import Calendar from "./pages/Calendar";
import Fondi from "./pages/Fondi";
import Collaborators from "./pages/Collaborators";
import ActivityLog from "./pages/Activity";
import Allievi from "./pages/Allievi";
import Notifiche from "./pages/Notifiche";
import SediTerritoriali from "./pages/SediTerritoriali";
import Rivenditori from "./pages/Rivenditori";
import Preventivi from "./pages/Preventivi";
import Antincendio from "./pages/Antincendio";
import MedicoCompetente from "./pages/MedicoCompetente";

function Protected({ children, ownerOnly, allow }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-400">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (ownerOnly && user.role !== "owner") return <Navigate to="/" replace />;
  if (allow && !allow.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="catalogo" element={<Catalog />} />
              <Route path="calendario" element={<Calendar />} />
              <Route path="fondi" element={<Fondi />} />
              <Route path="ordini" element={<Orders />} />
              <Route path="attestati" element={<Attestati />} />
              <Route path="vendite" element={<Sales />} />
              <Route path="preventivi" element={<Protected ownerOnly><Preventivi /></Protected>} />
              <Route path="antincendio" element={<Protected ownerOnly><Antincendio /></Protected>} />
              <Route path="medico-competente" element={<Protected allow={["owner", "collaboratore"]}><MedicoCompetente /></Protected>} />
              <Route path="allievi" element={<Allievi />} />
              <Route path="sedi-territoriali" element={<SediTerritoriali />} />
              <Route path="rivenditori" element={<Protected allow={["owner"]}><Rivenditori /></Protected>} />
              <Route path="notifiche" element={<Protected allow={["owner", "collaboratore"]}><Notifiche /></Protected>} />
              <Route path="aziende" element={<Protected allow={["owner", "collaboratore"]}><Companies /></Protected>} />
              <Route path="servizi" element={<Protected allow={["owner", "collaboratore"]}><Services /></Protected>} />
              <Route path="partner" element={<Protected allow={["owner", "collaboratore"]}><Partners /></Protected>} />
              <Route path="collaboratori" element={<Protected ownerOnly><Collaborators /></Protected>} />
              <Route path="attivita" element={<Protected ownerOnly><ActivityLog /></Protected>} />
              <Route path="sibill" element={<Protected ownerOnly><Sibill /></Protected>} />
              <Route path="pagamenti" element={<Protected allow={["owner", "partner"]}><Payments /></Protected>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
